module.exports = __webpack_public_path__ + "img/title0.240bd099.svg";